import { Box, Button, Link as MuiLink, Stack, Typography } from "@mui/material";

export default function GetStartedSection() {
  return (
    <Box
      sx={{
        py: 3,
        px: 3,
        position: "sticky",
        borderRadius: 2,
        bgcolor: "grey.200",
        top: 100,
        mt: 4,
      }}
    >
      <Typography component="div" variant="h5">
        What is Printy6?
      </Typography>
      <Box sx={{ mt: 2 }}>
        <Typography variant="body2">
          Printy6 is a print on demand and dropshipping service , we help people
          tur ideas into brands and products.
        </Typography>
        <Stack
          spacing={1}
          component="ul"
          sx={{
            pl: 2,
            mt: 2,
            "& li": {
              listStyleType: "disc",
            },
          }}
        >
          <li>Sign up for free</li>
          <li>Customize hundreds of products</li>
          <li>Sell online without inventory</li>
          <li>Reach customers worldwide</li>
        </Stack>
        <Typography variant="body2" sx={{ mt: 2 }}>
          Create unique products for yourself or start making money with your
          designs!
        </Typography>
        <MuiLink href="https://www.printy6.com/signup" underline="none">
          <Button variant="contained" sx={{ mt: 2 }} fullWidth>
            Get Started
          </Button>
        </MuiLink>
      </Box>
    </Box>
  );
}
